import { oc } from '@orpc/contract';
import { coverageMatrixInputSchema, coverageMatrixSchema } from '../schemas/benchmarks.schemas.js';
export const getCoverageMatrixContract = oc
    .route({
    method: 'GET',
    path: '/benchmarks/coverage-matrix/{vehicleId}',
    tags: ['Benchmarks'],
    summary: 'Per-scenario coverage of one vehicle: status, valid-run count and measured figures',
})
    .input(coverageMatrixInputSchema)
    .output(coverageMatrixSchema);
//# sourceMappingURL=get-coverage-matrix.contract.js.map